import { useEffect, useState } from "react";
import useHttpClient from 'shared/hooks/http-hook';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import { Card, Row, Form, Col, Select, Carousel, Image } from "antd";
import { headerStyle } from 'shared/styles/baseStyle';

export default function InstallationGuide() {
    const { responseData, sendRequest, requestIdentifier } = useHttpClient();
    const [marques, setMarques] = useState()
    const [models, setModels] = useState()
    const [photos, setPhotos] = useState()
    const [enableModels, setEnableModels] = useState(true)
    const [form] = Form.useForm();

    const formItemLayout = {
        labelCol: {
            span: 10,
        },
        wrapperCol: {
            span: 8
        },
    };

    useEffect(() => {
        sendRequest({
            endpoint: `{EndPoints.OBDGUIDE.GETMARQUES}`,
            method: 'GET',

        },
            'GETMARQUES')
    }, [])

    useEffect(() => {
        if (responseData && requestIdentifier === 'GETMARQUES') {
            setMarques(responseData)
        }
        if (responseData && requestIdentifier === 'GETMODELS') {
            setModels(responseData)
            setEnableModels(false)
        }
        if (responseData && requestIdentifier === 'GETPHOTOS') {
            setPhotos(responseData)
        }
    }, [responseData])

    const getModels = (id) => {
        form.setFieldsValue({
            'model': undefined
        })
        setPhotos(null)
        sendRequest({
            endpoint: `${EndPoints.OBDGUIDE.GETMODELS}?MarqueId=${id}`,
            method: 'GET',
        },
            'GETMODELS')
    }

    const getPhotos = (id) => {
        sendRequest({
            endpoint: `${EndPoints.OBDGUIDE.GETPHOTOS}?ModelId=${id}`,
            method: 'GET',
        },
            'GETPHOTOS')
    }

    return (
        <Card type="inner" headStyle={headerStyle} title=" Οδηγίες Εγκατάστασης">
            <Form form={form}   {...formItemLayout}>
                <Row justify="center">
                    <Col span={12}  >
                        <Form.Item name="marque" label="Μάρκα:"  >
                            <Select onChange={getModels} >
                                {marques?.map((marque) => <Select.Option key={marque.marque} value={marque.id}>{marque.marque}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify="center">
                    <Col span={12} >
                        <Form.Item name="model" label="Μοντέλο:">
                            <Select onChange={getPhotos} disabled={enableModels} >
                                {models?.map((model) => <Select.Option key={model.model} value={model.id}>{model.model}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {photos ? (
                    <Row justify="center">
                        <Col span={8}>
                            <Carousel dotPosition="top">
                                {Object.keys(photos).map((key) => photos[key] ? <Image src={photos[key]} width={500} /> : null)}
                            </Carousel>
                        </Col>
                    </Row>) : null}
            </Form>
        </Card >)
}

